<ag-grid-angular class="ag-theme-material ag-grid-list w-full h-full" style="height:fit-content;" rowSelection='single' [gridOptions]="gridOptions"
    [columnDefs]="columnDefs" [frameworkComponents]="frameworkComponents">
</ag-grid-angular>